import dayjs from 'dayjs';

/** Calendar day for API params. Does not convert through UTC. */
export const toApiDate = (d: Date) => dayjs(d).format('YYYY-MM-DD');
